import { ArticleTranslationDetails } from 'articleEditor/contexts/savingContext/savingStore';
import {
  ArticleStructure,
  currentVersion,
} from 'lib-knowledge-document-structure';
import {
  LanguageId,
  useArticleTranslationDraftUpdateMutation,
} from 'lib-knowledge-management-common/graphql';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

type MutationFunction = ReturnType<
  typeof useArticleTranslationDraftUpdateMutation
>[0];
type MutationReturnValue = ReturnType<MutationFunction>;
export type UpdateTranslationFn = (
  data: ArticleTranslationDetails,
) => MutationReturnValue;
type UseTranslationUpdateReturnValue = [
  UpdateTranslationFn,
  ReturnType<typeof useArticleTranslationDraftUpdateMutation>[1],
];

export function useTranslationUpdate(
  articleId: string,
  languageId: LanguageId,
): UseTranslationUpdateReturnValue {
  const [saveDraft, mutationResult] =
    useArticleTranslationDraftUpdateMutation();
  const update: UpdateTranslationFn = useCallback(
    ({ title, body, titleUpdatedAt, titleTranslatedAt }) => {
      const content: ArticleStructure = {
        version: currentVersion,
        children: body,
      };

      return saveDraft({
        variables: {
          articleId,
          languageId,
          content,
          title,
          titleUpdatedAt,
          titleTranslatedAt,
        },
        refetchQueries: ['ArticleTranslation'],
      }).then((args) => {
        ampli.knowledgeArticleUpdated({ articleId });
        return args;
      });
    },
    [saveDraft, articleId, languageId],
  );

  return [update, mutationResult];
}
